import { useState, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getRequiredFieldsForStep, shouldEnableNextButton } from '../helpers/buttonState';

const useNextButtonState = (
  currentStep,
  steps,
  componentMap,
  checkoutPageState,
) => {
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const { watch, formState: { errors }, control } = useFormContext();
  const formValues = useWatch({ control });

  const requiredFields = useMemo(() => getRequiredFieldsForStep(
    currentStep,
    steps,
    componentMap,
    checkoutPageState,
    formValues,
  ), [currentStep, steps, componentMap, checkoutPageState, formValues]);

  const watchedFieldValues = watch(requiredFields);

  useEffect(() => {
    const checkFields = () => {
      const isEnabled = shouldEnableNextButton(
        requiredFields,
        watchedFieldValues,
        errors,
      );
      setIsNextButtonEnabled(isEnabled);
    };

    checkFields();
  }, [requiredFields, watchedFieldValues, errors]);

  return isNextButtonEnabled;
};

export default useNextButtonState;
